import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import bgImage from '../images/background.png';

function CrIcon({ name, size = 20 }) {
    const p = { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.6, strokeLinecap: 'round', strokeLinejoin: 'round' };
    switch (name) {
        case 'back':   return <svg {...p}><path d="M19 12H5M12 19l-7-7 7-7"/></svg>;
        case 'shield': return <svg {...p}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>;
        case 'check':  return <svg {...p}><path d="M20 6 9 17l-5-5"/></svg>;
        default: return null;
    }
}

export default function Crear() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ name: '', text: '' });
    const [errors, setErrors]     = useState({});
    const [loading, setLoading]   = useState(false);
    const [ready, setReady]       = useState(false);

    useEffect(() => { requestAnimationFrame(() => setReady(true)); }, []);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData(prev => ({ ...prev, [id]: value }));
        if (errors[id]) setErrors(prev => ({ ...prev, [id]: null }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const errs = {};

        if (formData.name.length < 2 || formData.name.length > 15)
            errs.name = t('errors.name_length');
        if (formData.text.length < 2 || formData.text.length > 249)
            errs.text = t('errors.description_length');

        if (Object.keys(errs).length) { setErrors(errs); return; }

        setLoading(true);
        const userInfo = JSON.parse(localStorage.getItem('userLogged'));
        const data = new FormData();
        data.append('winegang_name', formData.name);
        data.append('text', formData.text);

        const xhr = new XMLHttpRequest();
        xhr.open('POST', `${process.env.REACT_APP_API_URL}/newgang/${userInfo.id}`, true);
        xhr.onreadystatechange = function () {
            if (this.readyState === 4) {
                setLoading(false);
                if (this.status === 200) navigate('/gangs');
            }
        };
        xhr.send(data);
    };

    const nameLen = formData.name.length;
    const textLen = formData.text.length;

    return (
        <div className={`cr-stage${ready ? ' cr-ready' : ''}`}>
            <div className="cr-bg" style={{ backgroundImage: `url(${bgImage})` }} />
            <div className="cr-vignette" />
            <div className="cr-grain" />

            <div className="cr-header">
                <button className="gn-back-btn" onClick={() => navigate(-1)} aria-label={t('common.back')}>
                    <CrIcon name="back" size={18} />
                </button>
                <div className="cr-header-center">
                    <CrIcon name="shield" size={15} />
                    <span className="cr-header-title">{t('gangs.create_title')}</span>
                </div>
                <div style={{ width: 40 }} />
            </div>

            <div className="cr-body">
                <form className="cr-form" onSubmit={handleSubmit} noValidate>

                    {/* Name field */}
                    <div className={`cr-field cr-field-name${errors.name ? ' cr-field-error' : ''}`}>
                        <div className="cr-field-icon">
                            <CrIcon name="shield" size={16} />
                        </div>
                        <div className="cr-field-inner">
                            <label className="cr-label" htmlFor="name">
                                {t('common.name')}
                            </label>
                            <input
                                id="name"
                                type="text"
                                className="cr-input"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder={t('gangs.placeholder_name')}
                                maxLength={15}
                                autoComplete="off"
                            />
                        </div>
                        <span className={`cr-counter${nameLen > 12 ? ' cr-counter-warn' : ''}`}>
                            {nameLen}/15
                        </span>
                    </div>
                    {errors.name && (
                        <p className="cr-error">{errors.name}</p>
                    )}

                    {/* Description field */}
                    <div className={`cr-field cr-field-desc${errors.text ? ' cr-field-error' : ''}`}>
                        <div className="cr-field-inner cr-field-inner-full">
                            <label className="cr-label" htmlFor="text">
                                {t('gangs.label_description')}
                            </label>
                            <textarea
                                id="text"
                                className="cr-textarea"
                                value={formData.text}
                                onChange={handleChange}
                                placeholder={t('gangs.placeholder_description')}
                                maxLength={249}
                                rows={4}
                            />
                        </div>
                        <span className={`cr-counter cr-counter-desc${textLen > 220 ? ' cr-counter-warn' : ''}`}>
                            {textLen}/249
                        </span>
                    </div>
                    {errors.text && (
                        <p className="cr-error">{errors.text}</p>
                    )}

                    <button
                        type="submit"
                        className={`cr-submit${loading ? ' cr-loading' : ''}`}
                        disabled={loading}
                    >
                        {loading ? (
                            <span className="cr-spinner" />
                        ) : (
                            <>
                                <CrIcon name="check" size={17} />
                                <span>{t('gangs.create')}</span>
                            </>
                        )}
                    </button>

                </form>
            </div>
        </div>
    );
}
